import './App.css';
import React from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { saveAs } from 'file-saver'
import { write, utils } from 'xlsx'
import axios from "axios";
import { api } from "./api/client";
import { createTheme,ThemeProvider,adaptV4Theme } from '@mui/material/styles';
import ExpandableRowEntry from "./ExpandableRowEntry";
import * as Debounce from './plug-in/DebounceSearchRender';
import ExpandableMakineServisGecmisi from "./ExpandableMakineServisGecmisi";
import { enhanceColumns, withTableOptions } from "./utils/tableDisplay";

class Makineler extends React.Component {


    constructor(props) {
        super(props);
        this.state={replace: "", datas:[], childRows:[], childRowId:0, open:false,dname:"",dsource:"" };
    }


    async getDatas(){

        const res = await api.get('/lookups/makineler/servis-gecmisi');

        const data = res.data;

        const products = data.map(d => ({
            "id":d.id ,
            "uyf_no":d.siparis_no,
            "seri_no":d.seri_no,
            "lokasyon":d.lokasyon,
            "firma" :  d.musteri,
            "makine":d.makine,
}))
        //console.log(products);
        this.setState({datas: products})
    }

    componentDidMount() {
        this.getDatas(true);
    }

    render() {
        const myTheme  = createTheme(adaptV4Theme({
            overrides: {
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: '#eee'
                        },
                        '&:nth-child(even)': {
                            backgroundColor: '#fff'
                        },
                        lineHeight: 0.5,
                        padding:1
                    },
                },
                MuiTableCell: {
                    head: {
                        backgroundColor: "#e59e53 !important",
                        fontWeight: "bold",
                        padding:5
                    },
                    root: {
                        lineHeight:0.5
                    }
                },
                MUIDataTable: {

                    responsiveScroll: {
                        minHeight:'80vh'
                    },
                },
            },
        }));
        const columns = [
            {
                name: "uyf_no",
                label: "UYF No",
                options: {
                    filter: false,
                    customBodyRender: (value, meta, updateValue) => {
                        const record = data[meta.currentTableData[meta.rowIndex].index];
                        return (
                            <a href={'http://coiltech.biz/pdfer/uyf.php?id='+record.id} target={'_blank'} rel={'noreferrer'}> {value} </a>
                        );

                    },
                },
            },
            {
                name: "seri_no",
                label:"Seri No",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "makine",
                label:"Makine Adı",
                options: {
                    filter:false,
                    sort:false,
                }
            },
            {
                name: "firma",
                label:"Müşteri",
                options: {
                    filter:false,
                    sort:false,
                }
            },


            {
                name: "lokasyon",
                label: "Lokasyon",
                options: {
                    filter: true,
                    filterOptions: {
                        fullWidth: true
                    },

                },
            },

        ];
        const data =  this.state.datas;

        let datas=[];
        const options = {
            filter: true,
            onFilterChange: (changedColumn, filterList) => {
                console.log(changedColumn, filterList);
            },
            selectableRows: false,
            filterType: 'multiselect',
            responsive: "vertical",
            rowsPerPage: 100,
            fixedHeader: true,
            //fixedSelectColumn: true,
            tableBodyHeight: '100%',
            print:false,
            download:true,
            draggableColumns: {
                enabled:false,
                transitionTime:400
            },
            searchOpen:true,
            rowStyle: {
                fontSize: 9,
            },
            downloadOptions: {
                filterOptions: {
                    useDisplayedColumnsOnly: true,
                    useDisplayedRowsOnly: true
                }
            },
            onRowSelectionChange : (curRowSelected, allRowsSelected) => {
                datas.length=0;
                console.log("---RowSelect")
                console.log("Row Selected: ", curRowSelected);
                console.log("All Selected: ", allRowsSelected);

                if(allRowsSelected) {
                    allRowsSelected.forEach((result)=>{
                        datas.push(data[result.dataIndex]);
                    })
                }
            },
            textLabels :{
                selectedRows: {
                    text: "satır seçildi",
                    delete: "SiparişeEkle",
                    deleteAria: "Seçilenleri siparişe aktar",
                },
                pagination: {
                    next: "İleri",
                    previous: "Geri",
                    rowsPerPage: "Sayfadaki satır sayısı:",
                    displayRows: "/",
                },
                toolbar: {
                    search: "Ara",
                    downloadCsv: "XLSX İndir",
                    print: "Çıktı Al",
                    viewColumns: "Sütunları Göster",
                    filterTable: "Tabloyu Süz",
                },
                filter: {
                    all: "Tümünü Göster",
                    title: "Filtreler",
                    reset: "Sıfırla",
                },
                viewColumns: {
                    title: "Sütunları Göster",
                    titleAria: "Sütunları Göster/Gizle",
                },

            },
            onDownload: (buildHead, buildBody, columns, values) => {
                const fileType =
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                const fileExtension = ".xlsx";

                console.log(values.forEach(val => console.log(val)));

                const json = values.reduce((result, val) => {
                    const temp = {};
                    val.data.forEach((v, idx) => {
                        temp[columns[idx].name] = v;
                    });
                    result.push(temp);
                    return result;
                }, []);

                const fileName = `Müşteri Listesi`;
                const ws = utils.json_to_sheet(json);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
                const data = new Blob([excelBuffer], { type: fileType });
                saveAs(data, fileName + fileExtension);
                // cancel default  CSV download from table
                return false;
            },
            expandableRows: true,
            customSearchRender: Debounce.debounceSearchRender(500),

            renderExpandableRow: (rowData, rowMeta) => {

                return ( <ExpandableMakineServisGecmisi rowData={rowData} rowMeta={rowMeta} />   );
            },
        };

        return (
            <ThemeProvider theme={myTheme}>
                <MUIDataTable title={"Makinelerin Servis Geçmişi"} data={data} columns={enhanceColumns(columns)} options={withTableOptions(options)} />
            </ThemeProvider>
        );

    }
}

export default Makineler;
